import React from 'react';
import { createScene7ImgUrl } from '@libs/shared-ui';
import type { MagnifierViewProps } from './types';
import './MagnifierView.scss';

export function MagnifierView({
    imgSrc,
    imagePos,
    carouselWidth,
    carouselHeight,
    showMagnifier,
    positionOffset = 0,
    zoomLevel = 4,
}: MagnifierViewProps) {
    if (!imgSrc || !carouselWidth || !carouselHeight || !showMagnifier) {
        return null;
    }

    const IMAGE_SIZE_MAGNIFIER = {
        width: 1400,
        height: 1400,
    };
    let optimizedImgUrl = imgSrc;
    if (imgSrc.includes('scene7')) {
        optimizedImgUrl = createScene7ImgUrl(imgSrc, IMAGE_SIZE_MAGNIFIER);
    }

    const [x, y] = imagePos;
    const magnifierWidth = carouselWidth * 2;
    const magnifierHeight = carouselHeight * 2;

    const backgroundWidth = carouselWidth * zoomLevel;
    const backgroundHeight = carouselWidth * zoomLevel;

    const backgroundPosX = -(x * zoomLevel) + magnifierWidth / 2;
    const backgroundPosY = -(y * zoomLevel) + magnifierHeight / 2;
    return (
        <div
            className="image-magnifier__view"
            style={{
                display: showMagnifier ? '' : 'none',
                width: `${magnifierWidth}px`,
                height: `${magnifierHeight}px`,
                left: `${carouselWidth + positionOffset}px`,
                backgroundImage: `url('${optimizedImgUrl}')`,
                backgroundPositionX: `${backgroundPosX}px`,
                backgroundPositionY: `${backgroundPosY}px`,
                backgroundSize: `${backgroundWidth}px ${backgroundHeight}px`,
            }}
        />
    );
}
